import React from 'react';
import {Image} from 'antd-mobile';
import {toPriceStr} from '@components/utils';
import {useTranslation} from 'react-i18next';

interface TaskItemProps {
  icon: string;
  label: string;
  completed: number;
  target: number;
  buttonText: string;
  iconClassName?: string;
  rewardReceived?: boolean;
  onButtonClick?: () => void;
}

const TaskItem: React.FC<TaskItemProps> = ({
  icon,
  label,
  completed,
  target,
  buttonText,
  iconClassName = 'w-3 h-[13px]',
  rewardReceived = false,
  onButtonClick,
}) => {
  const {t} = useTranslation();
  const taskCompleted = completed >= target;
  const actionDisabled = taskCompleted || rewardReceived;
  const actionText = rewardReceived
    ? t('weeklyCheckIn.completed')
    : taskCompleted
    ? t('weeklyCheckIn.achieved')
    : buttonText;

  const handleButtonClick = () => {
    if (!actionDisabled) {
      onButtonClick?.();
    }
  };

  return (
    <div className="flex gap-6 h-8 items-center">
      <div className="flex-1 flex gap-2 items-center min-w-0">
        <div className="bg-[#FF7F36] rounded-full shrink-0 size-6 overflow-hidden flex items-center justify-center">
          <Image className={iconClassName} src={icon} />
        </div>
        <p className="flex-1 capitalize font-medium text-[#31373D] text-xs tracking-[-0.3px] min-w-0">
          <span>{label}: </span>
          <span className="font-bold text-[red]">
            {toPriceStr(completed, {fixed: 0})}
          </span>
          /{toPriceStr(target, {fixed: 0})}
        </p>
      </div>
      <div
        role="button"
        aria-disabled={actionDisabled}
        tabIndex={actionDisabled ? -1 : 0}
        onClick={handleButtonClick}
        onKeyDown={event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleButtonClick();
          }
        }}
        className="border border-[#00B512] rounded-[28px] px-3 py-2 h-6 flex items-center justify-center shrink-0 shadow-[inset_0_1px_0_0_rgba(255,255,255,0.2)] cursor-pointer">
        <p className="font-bold text-[#00B512] text-[10px] whitespace-nowrap">
          {actionText}
        </p>
      </div>
    </div>
  );
};

export default TaskItem;
